import {
    createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import Error404 from './Error404.js';
import App from '../App.js';
import Admin from '../Admin.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <Error404 />,
    },
    {
        path: '/app/*',
        element: <App />,
        errorElement: <Error404 />,
    },
    {
        path: '/admin',
        element: <Admin m={11} />,
        errorElement: <Error404 />,
    },
    {
        path: '/admin/appinfos',
        element: <Admin m={11} />,
        errorElement: <Error404 />,
    },
    {
        path: '/admin/log/operations',
        element: <Admin m={21} />,
        errorElement: <Error404 />,
    },
]);

export default BasicRouter